var Backbone = require('backbone'),
    API = require('./api'),
    Marionette = require('marionette'),
    DocLockState = require('./docLockState');

require('backbone.radio');


/**
 * Mixing in API.function allows forwarding of fns from API requests, responses to here
 * Left-Over from Main Point of functionality in older version, incorporated here
 */

var API = new API();

module.exports = Backbone.Model.extend( _.extend({

    defaults: {

        currentPage: null, // start null in case no pages in document
        fullPageModel: null, //aways created on page change from currentPage (docMode) change

        activeNote: null,  // trigger's 'edit' mode for pgNotes
        activeNoteSubType: null,  // eg 'rect' or 'poly' --> could be taken off here

        documentLockState: new DocLockState(), // flag indicating the Document was locked by this application and the source(s) of the lock

        expandedNote: null,    //in page mode: when changing page on an edit -- only fire when this is true
        viewMode: '',

        /* note: not reset on doc change*/
        documentViewScale: null, // not may not always exist: eg if we don't include doc mode from setting/series of them
        pageViewScale:  null,  //  a reference to the pgModel in page mode -- needed for reloading images on loading in: also: a change sets the model for the View

        numberImagesLoadingInDocMode: 0, //NOTE: NOW JUST flag so that not more than a certain number of images can load at a time (settings) checked in prefetch
            //todo: set on init from actual settings
            //todo: not preventing on load not being set

        /* triggers */
        fullScreenMode: false,  //TODO: layout
        loadImages: true, //flat: if set to false (eg from fullTextQuickView setting), will disallow loading of images (toggle again when no longer 'covering')

        paneIsCoveringLayout: false, //would really only apply on entry -- todo: put on layout?, note: changed w/toggle load images
        panelIsResizing: false, /* true if user is resizing the panels -- toggles allowing note view hovers (and thus shape highlights */

        viewerLoaded: false, /* needs to be reset on doc change; here, really implies viewerLoaded for active document; UPDATE: really mains 'LAYOUT' loaded in the main WF( vs logged out mode ); should change name accordingly */
        pdfRendered: false, //store whether the PDF has already been rendered; set to false if want to reload pdf on reentry into mode (eg: rotation)

        showPageTextMode: 0,

        textOnlyMode: false,

        findAndRedactSearchModel: null

    },
    /* applied to channel events */
    events: {
        'change:viewerLoaded':          'viewerLoaded',

        'change:activeNote':            'changeActiveNote',
        'change:activeNoteSubType':     'changeActiveNoteSubType',
        'change:currentPage':           'changeCurrentPage',
        'change:expandedNote':          'changeExpandedNote',
        'change:viewMode':              'changeViewMode',


        'change:loadImages':            'toggleLoadImages',

        //TODO: to layout
        'change:fullScreenMode':        'toggleFullScreenMode',
        'change:panelIsResizing':       'panelResizingChange',

        'change:showPageTextMode':      'togglePageTextMode',
        'change:textOnlyMode':          'toggleTextOnlyMode'

    }, /* applied to channel events */
    scaleEvents: {
        'change:scale':         'scaleChange',
        'change:scaleType':     'scaleTypeChange'
    },
    initialize: function() {
        _.bindAll(this, 'setScale');
    },
    /* now must be done post init */
    onListenToViewerChannel: function(vCh) {
        this.vChannel = vCh; //(need ref for now b/c 'api' cxt is state)
        /* forward to channel -- already stored on channel file pre load of state model */
        this.on('all', function() {
            vCh.trigger.apply(vCh, arguments); //though cxt overwritten to the viewer (see subap)
        });
        /* forward radio methods to channel */      //TODO: mixin
        _.each(['trigger', 'command', 'request', 'commandOn', 'requestOn'], function(action) {
            this[action] = function() {
                return vCh[action].apply(vCh, arguments);
            };
        }, this);
    },

    /**
     * (Scale models must first be initialized)
     * change:scale change:scaleType -- don't really need scale events
     * trigger cxt could be overwritten to the viewer (see subap)
     */
    onListenToScaleEvents: function(scaleModel) {

        var vCh = this.vChannel;
        this.listenTo(scaleModel, 'all', function() {
            vCh.trigger.apply( vCh, arguments );
        });

    },

    onResetFromDocChange: function() {

        this.set({
            viewerLoaded: false,
            pdfRendered: false,
            activeNote: null, //in case not prevented on change
            expandedNote: null
        }, {silent: true});


    },

    // TODO: get all bbprops in helper ...
    onDestroy: function() {

        var attrs = _.toArray(

            _.pick( this.attributes, 'documentViewScale', 'pageViewScale', 'currentPage', 'fullPageModel',
                'activeNote', 'expandedNote', 'findAndRedactSearchModel'
            )
        );

        Marionette.blindTriggerOn(attrs, 'destroy');

        this.clear({silent: true});
        this.stopListening(); //scale model
        this.off();
    }

}, API.commands, API.requests));


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/state/state.js
 ** module id = 100
 ** module chunks = 0
 **/